import { makeStyles } from 'tss-react/mui';

export const useStackedBarChartWidgetStyles = makeStyles({
  name: 'StackedBarChartWidget',
})(theme => ({
  root: {
    padding: theme.spacing(6),
    paddingBottom: theme.spacing(20),
  },
  title: {
    display: 'flex',
  },
}));
